export default __webpack_public_path__ + "static/media/ihr-klare-seraphim.79782acd.pdf";